'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class Select extends _react.PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    let value = e.target.value;
    props.onChange({
      e: e,
      value: value,
      name: props.name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    let error_msg,
      status = props.status[props.name] || {};
    let class_name = props.className || '';
    const id = String(++app.form_index);
    const full_width = ![false, 'false'].includes(props['full-width']);
    if (full_width) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    if (status && status.error) {
      error_msg = /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, status.error);
    }
    const options = (props.options || []).map(function (option, key) {
      let output = /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        className: "select__options",
        value: option.value,
        key: key
      }, option.label || option.value || '');
      return output;
    });
    let styles = {
      ...(props.style || {})
    };
    if ([true, 'true'].includes(props['no-margin'])) {
      styles = {
        formControl: {
          marginTop: 0
        }
      };
    }
    const no_value_option = ![false, 'false'].includes(props['no-value-option']) ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: "",
      style: {
        display: 'none'
      }
    }) : undefined;
    const label = props.label ? /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      htmlFor: id
    }, props.label) : undefined;
    const value = typeof props.value === 'undefined' ? props['default-value'] || '' : props.value;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name,
      style: props.style
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      fullWidth: full_width,
      error: Boolean(status.error),
      style: styles
    }, label, /*#__PURE__*/_react.default.createElement(_Select.default, {
      id: id,
      onChange: component.handleChange,
      value: value,
      name: props.name,
      required: props.required || false,
      input: /*#__PURE__*/_react.default.createElement(_Input.default, null),
      disabled: props['read-only'] === true
    }, no_value_option, options), error_msg));
    return output;
  }
}
exports.default = Select;
